(function () {
    'use strict';

    angular.module("imApp").factory("factoryMenuService", ['$ihttp', function ($ihttp) {
        let service = {
            getMenu: function (parms) {
                return $ihttp.post({
                    method: 2026,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
